import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {
  UpSellingContainer,
  HeaderTile,
  CheckoutButton,
  UpSelling,
  CheckoutButtonText,
  UpSellingCategory
} from './UpSellingModal.style';
import {FormattedMessage} from 'react-intl';
import {CloseButton} from '../Modal/modal.style';
import {ButtonSpinner} from '../../styles/components/button.style';
import Isvg from 'react-inlinesvg';
import closeImg from '../../../public/images/close.svg';

import Meal from '../Meal/Meal';
import {ButtonsHolder, Cancel, Wrapper} from '../Meal/BasketModalItem.style';
import {Price} from '../Price/Price';
import {ANALYTICS_EVENT_CATEGORIES, ITEM_ORIGIN, SERVICE_TYPE} from '../../constants/constant';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {boolToServiceType} from '../../helpers/formHelper';
import {sortItemByGroup} from '../../helpers/upSellingHelper';

class UpSellingModal extends PureComponent {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.continueToCheckOut = this.continueToCheckOut.bind(this);
    this.showMealModal = this.showMealModal.bind(this);
    this.addItemStraightToBasket = this.addItemStraightToBasket.bind(this);
    this.sortedItems = sortItemByGroup(props.menu.meals, props.items);
  }

  componentWillMount() {
    GoogleAnalyticsHelper.trackUpSellingOpen(this.props.items);
  }

  closeModal() {
    GoogleAnalyticsHelper.trackUpSellingClose();
    this.props.closeModalCallback();
  }

  continueToCheckOut() {
    const {basket, continueToCheckOutCallback} = this.props;
    const serviceType = basket.fulfillment ?
      boolToServiceType(basket.fulfillment.delivery) :
      SERVICE_TYPE.COLLECTION;
    GoogleAnalyticsHelper.trackUpSellingCheckout(basket.items, serviceType);
    continueToCheckOutCallback();
  }

  showMealModal(meal) {
    return this.props.showMealModal(meal, ITEM_ORIGIN.UPSELL);
  }

  addItemStraightToBasket(meal) {
    return this.props.addItemStraightToBasket(meal, ITEM_ORIGIN.UPSELL);
  }

  render() {
    const {isSideBasketLoading, restaurantModes, menu, basket} = this.props;

    const renderCheckoutButtonSpinner = isSideBasketLoading && <ButtonSpinner />;
    const renderCheckoutButtonText = !isSideBasketLoading && (
      <CheckoutButtonText>
        <FormattedMessage id="upSelling.checkout" />
        <Price amount={basket.price.total} />
      </CheckoutButtonText>
    );

    const upSellingItems = this.sortedItems.map(category => (
      <UpSelling key={category[0]}>
        <UpSellingCategory>{category[0]}</UpSellingCategory>
        {
          category[1].map(item => (
            <Meal
              key={menu.meals[item].uuid}
              meal={menu.meals[item]}
              addItemStraightToBasket={this.addItemStraightToBasket}
              restaurantModes={restaurantModes}
              isOfflineMenu={false}
              showMealModal={this.showMealModal}
              showMealAddButton={true}
              showMealMoreButton={false}
              serverOffline={false}
              compact={true}
              parent={ANALYTICS_EVENT_CATEGORIES.UPSELL}
              hideDropDownPic={true}
            />
          ))
        }
      </UpSelling>
    ));

    return (
      <Wrapper>
        <CloseButton onClick={this.closeModal}><Isvg src={closeImg} /></CloseButton>
        <UpSellingContainer>
          <HeaderTile><FormattedMessage id="upSelling.title" /></HeaderTile>
          {upSellingItems}
        </UpSellingContainer>
        <ButtonsHolder>
          <Cancel onClick={this.closeModal}><FormattedMessage id="upSelling.cancel" /></Cancel>
          <CheckoutButton
            isLoading={isSideBasketLoading}
            onClick={this.continueToCheckOut}
            disabled={isSideBasketLoading}
            noTopMargin={true}
          >
            {renderCheckoutButtonSpinner}
            {renderCheckoutButtonText}
          </CheckoutButton>
        </ButtonsHolder>
      </Wrapper>
    );
  }
}

UpSellingModal.propTypes = {
  closeModalCallback: PropTypes.func,
  continueToCheckOutCallback: PropTypes.func,
  isSideBasketLoading: PropTypes.bool,
  menu: PropTypes.object,
  basket: PropTypes.object,
  items: PropTypes.array,
  addItemStraightToBasket: PropTypes.func,
  restaurantModes: PropTypes.object,
  showMealModal: PropTypes.func
};

export default UpSellingModal;



// WEBPACK FOOTER //
// ./components/UpSellingModal/UpSellingModal.js